import styled from "styled-components";
import Image from "next/image";
import {
  colors,
  spacing,
  stroke,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const BlockerContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing["5xl"]};
`;

export const BlockerImage = styled(Image)`
  width: 200px;
  height: 200px;
`;

export const BlockerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  align-items: center;
  text-align: center;
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const TextTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)}
  color: ${colors.text.base.primary}
`;

export const TextDesc = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Regular)}
  color: ${colors.text.base.secondary}
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  width: 100%;
  padding: ${spacing["2xl"]} ${spacing["2xl"]} ${spacing.none};
  border-top: ${stroke.xs} solid ${colors.border.state.default};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
    border-top: none;
  }
`;
